module.exports = __webpack_public_path__ + "img/hood edges length.33e4a149.png";